export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '2.25rem',
        left: '0.78rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '2.25rem',
        left: '0.75rem',
      },
      1: {
        bottom: '2.25rem',
        left: '1.47rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '2.25rem',
        left: '0.78rem',
      },
      1: {
        bottom: '2.25rem',
        left: '1.47rem',
      },
      2: {
        bottom: '2.25rem',
        left: '2.16rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesDynaGroCatalog.ts